import React, { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import ThermoPropertiesBlog from "./ThermoPropertiesBlog";

const ThermoPropertiesBlogPostList = () => {
    const [items, setItems] = useState([]);

    useEffect(() => {
        const fetchItems = async () => {
            try {
                const response = await fetch('/.netlify/functions/getThermoPropertiesBlogPostItems', {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                if (!response.ok) {
                    throw new Error(`HTTP error ${response.status}`);
                }

                const itemData = await response.json();

                // Flatten the data structure
                const flattenedItems = itemData.map(data => {
                    const { blogPost, categories, slugs, authors, tags } = data;
                    return {
                        ...blogPost,
                        slugName: slugs[0]?.slugName,  // Access the first slugName directly
                        categories,
                        authors,
                        tags
                    };
                });

                setItems(flattenedItems);

            } catch (error) {
                console.error('Error fetching Thermo Properties blog posts:', error);
            }
        };

        fetchItems();
    }, []);

    return (
        <div>
            <Grid container spacing={3}>
                {items.map((item) => (
                    <Grid item xs={12} key={item.id}>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <ThermoPropertiesBlog item={item} />
                            </Grid>
                        </Grid>
                    </Grid>
                ))}
            </Grid>
        </div>
    );

};

export default ThermoPropertiesBlogPostList;
